import {useState, useEffect} from 'react';
import api from '../api';


export const useResultJson = ({route, job, token}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    console.log('Querying ' + route)
    console.debug(job)
    if ((job.status === 'queued') || (job.status === 'pending')) {
      console.debug("returning early because job is not ready")
      return
    }
    const fetchJson = async () => {
      const row = d => {
        d.probability = +d.probability;
        d.cc = +d.cc;
        d.db = +d.db;
        d.iteration = +d.iteration;
        return d;
      }
      await api.get(
        route, {
          params: {
            job_id: job.id
          },
          headers: {
            authorization: token
          },
        }
      ).then(
        response => setData(JSON.parse(response.data))
       ).catch(
        error => {
          if (error.response.status === 408) {
            setData(null)
            return
          }
        }
      );
    }
    fetchJson();
  }, [job, route, token]);
  return data;
}


